import React from 'react';
import {toJS} from 'mobx';
import { observer, inject } from 'mobx-react';
import uuid from 'uuid4'

//style
import './index.scss';

//Icon
import Icon from '@mdi/react'
import {mdiPlus} from '@mdi/js'
import { mdiDotsVertical, mdiSubdirectoryArrowRight, mdiCloudUpload, mdiCloudDownload} from '@mdi/js'

//custom components
import CustomButton from '../../components/basic/CustomButton';
import CustomIconButton from '../../components/basic/customIconButton'
import EditOrAddCategory from './EditAdd'
import CustomSnackbar from '../../components/global/snackbar'
import ChangeSiblingsPositions from './ChangeSiblingsPositions'
import DeleteDialog from '../../components/global/deleteDialog';

//@material-ui
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

//API
import {api} from '../../functions/api'

//other libraries
import queryString from 'query-string'
import {isMobileSafari} from 'react-device-detect';
import ChangeParametersPosition from "./ChangeParametersPositions";

//const
const TIMEOUT = 3000;

@inject('internal')
@inject('translate')
@observer
export default class Categories extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
            openCreateNewDialog: false,
            siblingsDialog: false,
            children: [],
            isIOS: false,
            isCategoryParametersSortDialogOpened: false,
            categoryParameters: [],
            categoryParametersID: null
        }
    }

    tableHeader = [
        {
            "title": this.props.translate.i18n.GLOBAL.TABLE.TITLE,
            "numeric": false,
            "min_width": "150px"
        },
        {
            "title": this.props.translate.i18n.GLOBAL.TABLE.ACTIVE,
            "numeric": false
        },
        {
            "title": this.props.translate.i18n.GLOBAL.TABLE.POSITION,
            "numeric": false
        }
    ];
    tableBody = ["name", "production"]


    dropDownMenuItems = []

    setPermissions = () => {
        let permissions;
        if( toJS(this.props.internal.user.data.permissions) && toJS(this.props.internal.user.data.permissions.lists_categories))
        {
            permissions = toJS(this.props.internal.user.data.permissions.lists_categories);

        if(permissions.update) {
            let objEdit = {
                title: this.props.translate.i18n.GLOBAL.BUTTONS.EDIT,
                action: "edit"
            }
            this.dropDownMenuItems.push(objEdit);
            this.dropDownMenuItems.push({
                title: this.props.translate.i18n.MODULES.CATEGORIES.MENU.PARAMETERS_SORT,
                action: "sort-category-parameters",
                module: this
            });
        }

        if(permissions.destroy) {
            let objDelete = {
                title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
                action: "delete"
            }
            this.dropDownMenuItems.push(objDelete);
        }
    }

    }

    componentDidMount() {
        if(toJS(this.props.internal.user)
            && toJS(this.props.internal.user.data)
            && toJS(this.props.internal.user.data.permissions)
            && toJS(this.props.internal.user.data.permissions.lists_categories)
            && toJS(this.props.internal.user.data.permissions.lists_categories.view)){


            this.props.internal.setRoute(this.props.history, this.props.location.pathname)
            this.loadCategories();
            this.setPermissions()
            this.props.internal.resetParents()
            if(isMobileSafari) {
                this.setState({isIOS: true})
            }
        }
        else {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname)
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({
                message: "",
                openSnackbar: false
            })
        }, TIMEOUT)
    }

    emptyCategoryList = false;
    loadCategories = async(searchterm = "") => {
        this.setState({loading: true})

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }
        }

        let load_data = await api({
            method: 'get',
            url: 'lists/categories',
            authorization: this.props.internal.user.access_token,
            searchterm: searchterm
        })

        if(load_data.success === true) {
            if(load_data.data.data === null || load_data.data.data.length === 0) {
                this.emptyCategoryList = true;
                load_data.data.data = []
            }
            this.props.internal.setDataForTable(load_data.data)
            this.allZeroLevel();
        }

        this.setState({loading: false})
    }

    allZeroLevel = () => {
        this.props.internal.resetCatelogyToList()
        toJS(this.props.internal.dataForTable.data).map((rowData, rowIndex) => (
            this.otherLevels(rowData)

        ))

    }

    otherLevels = (rowData) => {

        this.props.internal.pushCategoryToList(rowData);
        let tmp = {}
        tmp.name = rowData.name
        tmp.id = rowData.id
        tmp.parent_id = rowData.parent_id
        this.props.internal.pushParentToParents(tmp)

        if(rowData.children) {
            rowData.children.map((childRowData, childRowDataIndex) => (
                this.otherLevels(childRowData)
            ))
        }
    }

    handleOpenCreateNewCategory = () => {
        this.setState({openCreateNewDialog: true})
    }



    handleCloseEditOrAddCategoryDialog = (refresh) => {
        if(refresh) {
            this.loadCategories()
        }

        let actionEditData = {
            edit: false,
            id: null
        }

        this.setState({openCreateNewDialog: false})
        this.props.internal.setActionEdit(actionEditData)
        this.props.internal.resetParents()
    }

    //data from add/edit dialog
    showSnackbar = (message, open) => {
        // this.loadCategories()
        this.setState({message: message, openSnackbar: open})
        this.turnOffSnackBar();
    }

    openDialogChangeSiblings = () => {
        this.setState({siblingsDialog: true})
    }

    handleCloseSiblingsDialog = () => {
        this.setState({siblingsDialog: false})
    }

    handleParametersPositionDialog = (refresh) => {
        this.setState({
            isCategoryParametersSortDialogOpened: false,
            categoryParameters: [],
            categoryParametersID: null
        });
    }

    openDialogSiblings = (clicked_element) => {
        this.props.internal.getChildrensInParent(clicked_element.data.parent_id)
        this.children = toJS(this.props.internal.children)

        //this.children = clicked_element.data.children
        this.setState({siblingsDialog: true})

    }

    handleSearch = (searchTerm) => {

        if (searchTerm.length > 2) {
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else {
            this.addQueryToUrl("searchterm", "")
        }
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadCategories()
    }

    handleCloseSnackbar = () => {
        this.setState({
            message: "",
            openSnackbar: false
        })
    };

    children = []

    handleDeleteCategory = async () => {
        this.props.internal.setActionDelete();
        let idCategory = this.props.internal.actionDeleteObj.id
        let delete_data = await api({
            method: 'delete',
            url: 'lists/categories/' + idCategory,
            authorization: this.props.internal.user.access_token,
        })

        if (delete_data.success && delete_data.success === true) {

            this.setState({message: delete_data.data.message, openSnackbar: true})
            this.loadCategories();

        }
        else {
            //this.props.internal.setSnackbar(delete_data.data.message, true)
            this.setState({message: delete_data.data.message, openSnackbar: true})
        }
        this.turnOffSnackBar();
    }

    updateProductionStatus = (data) => {
        this.setState({loading: data})
    }


    render() {
        let permissions;
        if(toJS(this.props.internal.user.data.permissions) && toJS(this.props.internal.user.data.permissions.lists_categories)) {
            permissions = toJS(this.props.internal.user.data.permissions.lists_categories);
        }


        const routerData = {
            history: this.props.history,
            location: this.props.location,
            match: this.props.match,
            internal: this.props.internal
        }

        return (
            this.state.loading
            ?
            <CircularProgress className = {'circular-progress'}/>
            :
            <div className={'categories'}>
                <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} />
                <ChangeSiblingsPositions
                    open={this.state.siblingsDialog}
                    onClose={this.handleCloseSiblingsDialog}
                    title={this.props.translate.i18n.MODULES.CATEGORIES.DIALOG_TITLE_CHANGE_SIBLINGS_POSITIONS}
                    childs={this.children}
                    showSnackbar={this.showSnackbar}
                />
                <ChangeParametersPosition
                    open={this.state.isCategoryParametersSortDialogOpened}
                    onClose={this.handleParametersPositionDialog}
                    title={this.props.translate.i18n.MODULES.CATEGORIES.DIALOG_TITLE_CHANGE_SIBLINGS_POSITIONS}
                    children={this.state.categoryParameters}
                    module={this}
                    idCategory={this.state.categoryParametersID}
                    showSnackbar={this.showSnackbar}
                />
                {this.props.internal.actionEdit.edit === true || this.state.openCreateNewDialog === true ?
                <EditOrAddCategory
                    open={this.props.internal.actionEdit.edit === true || this.state.openCreateNewDialog === true ? true : false}
                    onClose={this.handleCloseEditOrAddCategoryDialog}
                    title={ this.props.internal.actionEdit.edit ? this.props.translate.i18n.MODULES.CATEGORIES.DIALOG_TITLE_EDIT_CATEGORI : this.props.translate.i18n.MODULES.CATEGORIES.DIALOG_TITLE_CREATE_CATEGORI}
                    routerData={this.props.routerData}
                    showSnackbar={this.showSnackbar}
                    idCategory={this.props.internal.actionEdit.id}
                    idParent={this.props.internal.parent_id}
                />
                :
                null}
                <DeleteDialog
                    open={this.props.internal.actionDelete}
                    title={this.props.translate.i18n.MODULES.CATEGORIES.DELETE_CATEGORY_TITLE}
                    content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                    btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                    delete={this.handleDeleteCategory}
            />
                <div className = {'flex justify-right '} >
                    {/* <Search
                        placeholder = {this.props.translate.i18n.MODULES.CATEGORIES.SEARCH}
                        classes = {'clients-search-box '}
                        onChange = {this.handleSearch}
                    />  */}
                    {permissions && permissions.store
                        ?
                        <CustomButton
                            mystyle = {'btn-orange-bg border-radius-18'}
                            title = {this.props.translate.i18n.MODULES.CATEGORIES.ADD_NEW_CATEGORY}
                            onClick = {this.handleOpenCreateNewCategory}
                        >
                            <Icon path={mdiPlus} size = {1 }/>
                        </CustomButton>
                        :
                        null
                    }
                </div>

                <div className={'custom-table '}>
                    <Paper className={`table-box ${this.state.isIOS ? 'ios' : ''}`} >

                    <Table >
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                {this.tableHeader.map((data, index) => {
                                    return (
                                        <TableCell key={uuid()} numeric={data.numeric} style={{minWidth: `${data.min_width ? data.min_width : 0}`}} >
                                            {data.title}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!this.emptyCategoryList ?

                                toJS(this.props.internal.dataForTable.data).map((rowData, rowIndex) => (
                                    <TableBodyContent2 key={rowIndex} routerData={routerData} rowData={rowData} tableBody={this.tableBody} dropDownMenuItems={this.dropDownMenuItems} openDialogSiblings={this.openDialogSiblings} showSnackbar={this.showSnackbar} updateProductionStatus={this.updateProductionStatus}/>
                                ))
                                :
                                <TableRow><TableCell colSpan={4} style={{textAlign:'center'}}>{this.props.translate.i18n.GLOBAL.ALERTS.NO_FOUND_DATA_FOR_TABE}</TableCell></TableRow>
                            }

                            {/* <TableBodyContent data={toJS(this.props.internal.dataForTable.data)} tableBody={this.tableBody} dropDownMenuItems={this.dropDownMenuItems}/> */}
                        </TableBody>

                    </Table>
                    </Paper>
                </div>

            </div>

        );
    }

}


@inject('internal')
class TableBodyContent2 extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            siblingsDialog: false,
            editChild: null,
        }
    }

    openDialogSiblings = (e)=> {
        if(e) {
            this.props.openDialogSiblings(e);
        }

    }

    changeProduction = async(id, production) => {
        // this.props.updateProductionStatus(true)

        let update_data = await api({
            method: "patch",
            url: 'lists/categories/' + id,
            authorization: this.props.routerData.internal.user.access_token,
            params: {
                production: production

            }
        })

        if(update_data.success === true) {
            this.props.showSnackbar(update_data.data.message, true)
            this.props.routerData.internal.resetParents()
            // this.props.updateProductionStatus(false)
        }
    }




    render() {
        //let permissions = toJS(this.props.internal.user.data.permissions.lists_categories);
        const data = this.props.rowData
        return (

            <React.Fragment>
                <TableRow >
                    <TableCell className={'cell-with-icon'}>
                        <CustomIconButton
                            id={data.id}
                            label="More"
                            dropdownMenu
                            items={this.props.dropDownMenuItems}
                            module={'/categories'}
                            data={data}
                        >
                            <Icon path={mdiDotsVertical} size={1} />
                        </CustomIconButton>
                    </TableCell>

                    {this.props.tableBody.map((cellName, index) => {
                        return (
                            <TableCell
                                key={uuid()}
                                className={cellName === "name" ? `category-level-${data.level}` : " aling-center"}
                            >
                                {cellName === 'name' && data['level'] > 0 ? <Icon path={mdiSubdirectoryArrowRight} size={1} className={'icon-subcategory'}/> : null}

                                {cellName === "production"
                                    ?
                                        data[cellName]
                                        ?
                                        <Icon path={mdiCloudUpload} size={1} className={`production-${data[cellName]}`} onClick={() =>this.changeProduction(data.id, false)}/>
                                        :
                                        <Icon path={mdiCloudDownload} size={1} className={`production-${data[cellName]}`} onClick={() =>this.changeProduction(data.id, true)}/>
                                    :
                                    null

                                }
                                {cellName === "production"
                                    ?
                                    null
                                    :
                                    String(data[cellName])
                                }

                            </TableCell>

                        )
                    })
                    }
                    <TableCell className={'last-cell'}>

                        <IconButton aria-label="Menu" className={'burger-menu-btn'} onClick={e => this.openDialogSiblings({e, data})}>
                            <MenuIcon />
                        </IconButton>

                    </TableCell>

                </TableRow>

                {
                    data.children
                    ?
                    data.children.map((childRowData, childRowDataIndex) => (
                        <TableBodyContent2 key={childRowDataIndex} routerData={this.props.routerData} showSnackbar={this.props.showSnackbar} rowData={childRowData} dropDownMenuItems={this.props.dropDownMenuItems} tableBody={this.props.tableBody} openDialogSiblings={this.openDialogSiblings} updateProductionStatus={this.props.updateProductionStatus}/>
                    ))
                    :
                    null
                }

            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/categories/index.js